import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css'; // Import the custom CSS

import LorryButton from './Move';

const NavbarComponent = () => {
  const location = useLocation(); // Get the current location
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State to toggle menu

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle the menu visibility
  };

  return (
    <header className="header">
      <div className="logo">
        <Link to="/">
          <img src="/1.png" alt="Logo" />
        </Link>
      </div>
      <button
        className="menu-toggle"
        onClick={toggleMenu}
        aria-expanded={isMenuOpen}
        aria-controls="navbar"
      >
        {isMenuOpen ? (
          <span className="cross">✖</span>
        ) : (
          <>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </>
        )}
      </button>
      <nav className={`navbar ${isMenuOpen ? 'active' : ''}`}>
        <Link to="/" className={location.pathname === '/' ? 'active' : ''}onClick={toggleMenu}>Home</Link>
        <Link to="/SellYourCar" className={location.pathname === '/SellYourCar' ? 'active' : ''}onClick={toggleMenu}>Sell/Part Exchange</Link>
        <Link to="/Inventory" className={location.pathname === '/Inventory' ? 'active' : ''}onClick={toggleMenu}>Stock List</Link>
        <Link 
  to="/subcontractform" 
  target="_blank" 
  rel="noopener noreferrer" 
  
  className={location.pathname === '/subcontractform' ? 'active' : ''}
  onClick={toggleMenu}
>
  Vehicle Movement
</Link>

        <Link to="/ContactUs" className={location.pathname === '/ContactUs' ? 'active' : ''}onClick={toggleMenu}>Contact Us</Link>
        
        <LorryButton/>
        
      </nav>
    </header>
  );
};

export default NavbarComponent;
